<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      :size="'normal'"
      @cancel="cancel"
      @confirm="confirm"
  >
    <template #header>
      订单下载
    </template>
    <template #content>
      <el-row class="gj-mb10">
        <el-col :span="5" class="download-styl">
          <gj-required>订单类型</gj-required>
        </el-col>
        <el-col :span="17">
          <gj-select
              v-model="orderType"
              :options="saleOrderType"
              :clearable="false"
              :width="'350px'"
          >
          </gj-select>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5" class="download-styl">
          <gj-required>时间范围</gj-required>
        </el-col>
        <el-col :span="17">
          <gj-date-picker
              type="daterange"
              v-model="downloadDate"
              :clearable="false"
              :width="'350px'"
              :max-day-length="60"
          ></gj-date-picker>
        </el-col>
      </el-row>
    </template>
  </gj-modal>
</template>

<script>
    import {modalMixIn} from "../../../../../minxins";
    import {subDays} from 'date-fns'

    export default {
        name: "sale-order-download",
        mixins:[modalMixIn],
        props: {
          saleOrderType: null,
        },
        data() {
          return {
              orderType: null,
              downloadDate: [subDays(new Date(), 59), new Date()]
          }
        },
        methods: {
            confirm() {

            }
        }

    }
</script>

<style scoped>
  .download-styl {
    text-align: right;
    padding-right: 8px;
    padding-top: 8px;
  }
</style>
